import type { GenericTranslationsObject } from '@payloadcms/translations'

export const sv: GenericTranslationsObject = {
  $schema: '../translation-schema.json',
  'plugin-redirects': {
    customUrl: 'URL',
    documentToRedirect: 'Dokument',
    fromUrl: 'Från',
    internalLink: 'Intern länk',
    redirectType: 'Typ',
    toUrlType: 'Till',
  },
}
